import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header/header";
import Home from "./Pages/Home/home";
import Resources from "./Pages/Resource/Resources";
import Footer from "./Components/Footer/Footer";
import About from "./Pages/About/About";
import Job from "./Pages/Job/Job";
import JobSub from "./Pages/Job/JobSub";
import Placement from "./Pages/Placement/Placement";
import Training from "./Pages/Training/Training";
import Partners from "./Pages/Partners/Partners";
import Contact from "./Pages/Contact/Contact";
import CollegePartner from "./Components/PartnersComp/CollegePartner";
import CorporatePartner from "./Components/PartnersComp/CorporatePartner";
import NgoPartner from "./Components/PartnersComp/NgoPartner";
import Events from "./Pages/Eventpage/EventsPage";
import Form from './Components/Form/JobRecruitmentForm';
import ResourceBlog from './Components/ResourceComp/ResourceBlog';
import CorporateTraining from "./Components/TrainingComp/CorporateTraining";
import IndividualTraining from "./Components/TrainingComp/IndividualTraining";
import JoinPartnerForm from "./Components/Form/JoinPartnerForm";
import ResourceGuid from "./Components/ResourceComp/ResourceGuid";
import Testimonials from "./Pages/Testimonials/Testimonials";
import WorldwideJob from "./Pages/Job/WorldwideJobsSub";
import Courses from './Pages/Courses/Courses';
import Internship from './Pages/Internships/Internship';

export default function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/event" element={<Events />} />
        <Route path="/about" element={<About />} />
        <Route path="/job" element={<Job />} />
        <Route path="/jobSub" element={<JobSub />} />
        <Route path="/placement" element={<Placement />} />
        <Route path="/training" element={<Training />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/collegePartner" element={<CollegePartner />} />
        <Route path="/corporatePartner" element={<CorporatePartner />} />
        <Route path="/ngoPartner" element={<NgoPartner />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/form" element={<Form />} />
        <Route path="/worldwideJob" element={<WorldwideJob/>}/>
        <Route path="/joinPartnerForm" element={<JoinPartnerForm />} />
      <Route path="/tesimonials" element={< Testimonials/>}/>
        <Route path="/resourceBlog" element={<ResourceBlog />} />
         <Route path="/corporateTraining" element={<CorporateTraining />} />
        <Route path="/individualTraining" element={<IndividualTraining />} />
       <Route path ='/courses' element ={<Courses/>}/>
        <Route path="/resourceGuid" element={<ResourceGuid />} />
        <Route path="/resourceBlog" element={<ResourceBlog />} />
        <Route path ="/internship" element ={<Internship/>}/>
      </Routes>
      <Footer />
    </Router>
  );
}
